var map = {
	"./businessCard/bc_user.svg": "VV/k",
	"./businessCard/dialogue.svg": "pFLB",
	"./svg/403.svg": "8xPD",
	"./svg/500.svg": "Ip/S",
	"./svg/attachment.svg": "7Js6",
	"./svg/audio.svg": "KyOe",
	"./svg/autoincrementPack.svg": "lmyH",
	"./svg/back.svg": "RN8c",
	"./svg/back_icon.svg": "SlSf",
	"./svg/close_page.svg": "573u",
	"./svg/complete.svg": "PGk/",
	"./svg/dbf.svg": "+hxQ",
	"./svg/delete.svg": "Imjp",
	"./svg/delete_icon.svg": "juLI",
	"./svg/depIcon.svg": "23oz",
	"./svg/edit.svg": "ql+d",
	"./svg/excel.svg": "OLl3",
	"./svg/export.svg": "gmuv",
	"./svg/file_deauflt.svg": "OmKK",
	"./svg/file_space.svg": "4tOQ",
	"./svg/file_word1.svg": "2892",
	"./svg/folder.svg": "XXSE",
	"./svg/img.svg": "HnV6",
	"./svg/jiesuozhuangtai.svg": "vVRq",
	"./svg/jiesuozhuangtai1.svg": "JF35",
	"./svg/jiesuozhuangtai11.svg": "4+mW",
	"./svg/jiesuozhuangtaiW.svg": "NlkD",
	"./svg/local_file.svg": "9jB/",
	"./svg/multipleChoice.svg": "sL+A",
	"./svg/multiplePack.svg": "Yaor",
	"./svg/no_pass.svg": "5YmT",
	"./svg/org_icon.svg": "fPv7",
	"./svg/pass.svg": "UbXU",
	"./svg/pdf.svg": "M8Oc",
	"./svg/pending.svg": "HJAH",
	"./svg/ppt.svg": "4hoL",
	"./svg/preview.svg": "qZ2L",
	"./svg/query.svg": "XK2A",
	"./svg/question.svg": "noTa",
	"./svg/singleChoice.svg": "HBV4",
	"./svg/singleTex.svg": "MAyj",
	"./svg/submit.svg": "6yke",
	"./svg/submit_icon.svg": "C9Uq",
	"./svg/suodingzhuangtai.svg": "yt3a",
	"./svg/template.svg": "//Qc",
	"./svg/textDec.svg": "mXwQ",
	"./svg/txt.svg": "YXXy",
	"./svg/upload.svg": "P/TB",
	"./svg/user_icon.svg": "NqvL",
	"./svg/video.svg": "3JNx",
	"./svg/warn.svg": "a5SC",
	"./svg/word.svg": "ELgs",
	"./svg/workgroup_num.svg": "r7nb",
	"./svg/workgroup_space.svg": "sx5a",
	"./svg/xinghao.svg": "Cmqm",
	"./svg/zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "i+SB";


//////////////////
// WEBPACK FOOTER
// ./src/icons \.svg$
// module id = i+SB
// module chunks = 14